<div class="container mt-0 p-0">
  <div class="button-row d-flex align-items-center flex-row">
    <div class="flex-grow-1">
<div class="style-title m-0 text-left">
{{ evalutionData[0]?.category_title | titlecase }}
</div>

    </div>
    <div class="flex-grow-0">
      <div class="d-flex align-items-center gap-2">
        <button mat-raised-button color="accent" class="custom-accent-btn,back mx-2" (click)='Back_to_Evaluation_category()'>
          <mat-icon>arrow_back</mat-icon>
          Back
        </button>
        <button mat-raised-button color="primary" class="custom-primary-btn,addevalution" (click)="notificationpopup(modal123)">
          <mat-icon>add_circle</mat-icon>
          Add Evaluation
        </button>
      </div>
    </div>
  </div>

  <div class="card--grid">
    <div class="row">
      <div class="col-lg-4 mb-3" *ngFor="let s of paginatedItems">

      
    <mat-card class="evaluation-card mat-elevation-z8 w-100">
      <mat-card-header>
        <mat-card-actions class="mat-card-actions p-0 m-0 mb-3">
          <button mat-mini-fab color="primary" aria-label="Edit" (click)="notificationpopup2(modal1234, s)"
            matTooltip="Edit" class="action-btn">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-mini-fab color="warn" aria-label="Delete" (click)="delete(s)" matTooltip="Delete"
            class="action-btn">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card-header>

      <mat-card-image (click)="onImageClick(modalimage, s.image)" src="" alt="" class="card-image overflow-hidden">

        <img [src]="s.image" alt="{{ s.title }}" class="w-100">
      </mat-card-image>
      <div class="title">
        <mat-card-title>{{ s.title| titlecase }}</mat-card-title>
      </div>
      <div class="content">
        <mat-card-content>
          <p class="card-text">
            {{ s.content| titlecase }}
          </p>
        </mat-card-content>
      </div>
    </mat-card>
    </div>
    </div>
  </div>

<mat-paginator
  [length]="evalutionData.length"
  [pageSize]="pageSize"
  [pageSizeOptions]="[6, 12, 24]"
  showFirstLastButtons
  (page)="onPageChange($event)">
</mat-paginator>
  <div *ngIf="!evalutionData.length" class="no-data">No data found</div>
</div>
<ng-template #modal123 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">ADD Evalution</h4>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <form [formGroup]="editevalution" class="w-100">
        <div class="col-md-12 form-group mb-3">
          <label for="firstName">Title</label>
          <input maxlength="100" formControlName="title" type="text" class="form-control form-control-rounded">
          <div
            *ngIf="editevalution.controls['title'].errors && (!editevalution.controls['title'].pristine || submitted  )"
            class="error-msg">
            <div class="text-danger" *ngIf="editevalution.controls['title'].hasError('required')">
              Title is required.
            </div>
            <div class="text-danger" *ngIf="editevalution.controls['title'].hasError('maxlength')">
              Title cannot exceed 100 characters.
            </div>
            <div class="text-danger" *ngIf="editevalution.controls['title'].hasError('minlength')">
              Title must be at least 2 characters long
            </div>
          </div>
        </div>

        <div class="col-md-12 form-group mb-3">
          <label for="lastName">
            Description</label>
          <textarea maxlength="1000" formControlName="content" class="form-control form-control-rounded">
                  </textarea>
          <div
            *ngIf="editevalution.controls['content'].errors && (!editevalution.controls['content'].pristine || submitted)"
            class="error-msg">
            <div class="text-danger" *ngIf="editevalution.controls['content'].hasError('required')">

              Description must be at least 2 characters long.
            </div>
            <div class="text-danger" *ngIf="editevalution.controls['content'].hasError('maxlength')">

              Description cannot exceed 1000 characters.
            </div>
            <div class="text-danger" *ngIf="editevalution.controls['content'].hasError('minlength')">

              Description Minlength should be 2 characters..
            </div>
          </div>
        </div>
        <!-- <div class="col-md-12 form-group mb-3">
  <label for="title">Select a Evalution</label>
  <select formControlName="title" class="form-control form-control-rounded" *ngFor="let t of titleOptions">
    <option value="" disabled selected>Select a Evalution</option>
    <option>{{ t.id }}</option>
  </select>

  <div
    *ngIf="editevalutionEdit.controls['title'].errors && (!editevalutionEdit.controls['title'].pristine || submitted)"
    class="error-msg">
    <div class="text-danger" *ngIf="editevalutionEdit.controls['evalution'].hasError('required')">
       Evalution is required.
    </div>
  </div>
</div> -->
        <!-- <div class="col-md-12 form-group mb-3">
          <label for="title">Select an Evaluation Style</label>
          <select formControlName='evaluation_category_id' class="form-control form-control-rounded">
            <option value="" disabled selected>Select an Evaluation Style</option>
            <option *ngFor="let t of titleOptions" [value]="t.id">{{ t.title }}</option>
          </select>

          <div
            *ngIf="editevalution.controls['evaluation_category_id'].errors && (!editevalutionEdit.controls['evaluation_category_id'].pristine || submitted)"
            class="error-msg">
            <div class="text-danger" *ngIf="editevalution.controls['evaluation_category_id'].hasError('required')">
              Evaluation Style is required.
            </div>
          </div>
        </div> -->
<div class="col-md-12 form-group mb-3">
  <label for="title">Select an Evaluation Style</label>
  <div class="select-wrapper">
    <select formControlName="evaluation_category_id" class="form-control form-control-rounded">
      <option value="" disabled selected>Select an Evaluation Style</option>
      <option *ngFor="let t of titleOptions" [value]="t.id">{{ t.title }}</option>
    </select>
    <span class="select-icon">&#x25BC;</span> <!-- Downward triangle -->
  </div>
  <div
    *ngIf="editevalution.controls['evaluation_category_id'].errors && (!editevalution.controls['evaluation_category_id'].pristine || submitted)"
    class="error-msg">
    <div class="text-danger" *ngIf="editevalution.controls['evaluation_category_id'].hasError('required')">
      Evaluation Style is required.
    </div>
  </div>
</div>
        <div class="col-md-12 form-group mb-3">
          <label> Image</label>
          <input type="file" class="form-control form-control-rounded image input" (change)="onFileChange($event)"
            id="fileInput" />

          <div *ngIf="imageSelected">
            <div class="row mb-3">
              <div class="col-lg-4">
                <img id="imageToCrop" style="max-width: 100%; margin-top: 20px;" *ngIf="imageSelected" />
              </div>
              <div class="col-lg-4 text-left" *ngIf="imageSelected">
                <button (click)="cropImage()" class="btn1 btn btn-primary"
                  style="margin-top: 20px;margin-left: 50px;">Crop Image</button>
              </div>
              <div class="col-lg-4">
                <div class="cropper-wrapper" *ngIf="croppedImage">
                  <p class="mb-1 mt-3 text-center"><b>Cropped Image</b></p>
                  <div class="profile-picture">
                    <img class="croped_round_image" [src]="croppedImage" (error)="onImageError($event)"
                      alt="Profile Picture" />
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div *ngIf="submitted && !imgdata" class="text-danger">
            Image is required
          </div>
           <div *ngIf="imagesize" class="text-danger">
            Image size must be 5 MB or less
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-rounded"
      (click)="modal.dismiss('cancel')">Cancel</button>
    <button ngbAutofocus class="btn btn-danger btn-rounded" (click)="submitEvaluationData()">Ok</button>
  </div>
</ng-template>
<ng-template #modal1234 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Update Evalution</h4>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <form [formGroup]="editevalutionEdit" class="w-100">
        <div class="col-md-12 form-group mb-3">
          <label for="firstName">Title</label>
          <input maxlength="100" formControlName="title" type="text" class="form-control form-control-rounded">
          <div
            *ngIf="editevalutionEdit.controls['title'].errors && (!editevalutionEdit.controls['title'].pristine || submitted  )"
            class="error-msg">
            <div class="text-danger" *ngIf="editevalutionEdit.controls['title'].hasError('required')">
              Title is required.
            </div>
            <div class="text-danger" *ngIf="editevalutionEdit.controls['title'].hasError('maxlength')">
              Title cannot exceed 100 characters.
            </div>
            <div class="text-danger" *ngIf="editevalutionEdit.controls['title'].hasError('minlength')">
              Title must be at least 2 characters long.
            </div>
          </div>
        </div>


        <div class="col-md-12 form-group mb-3">
          <label for="lastName">
            Description</label>
          <textarea maxlength="1000" formControlName="content" class="form-control form-control-rounded">
              </textarea>
          <div
            *ngIf="editevalutionEdit.controls['content'].errors && (!editevalutionEdit.controls['content'].pristine || submitted)"
            class="error-msg">
            <div class="text-danger" *ngIf="editevalutionEdit.controls['content'].hasError('required')">

              Description is required.
            </div>
            <div class="text-danger" *ngIf="editevalutionEdit.controls['content'].hasError('maxlength')">

              Description cannot exceed 1000 characters.
            </div>
            <div class="text-danger" *ngIf="editevalutionEdit.controls['content'].hasError('minlength')">

              Description must be at least 2 characters long .
            </div>
          </div>
        </div>
        <!-- <div class="col-md-12 form-group mb-3">
  <label for="title">Select a Evalution</label>
  <select formControlName="title" class="form-control form-control-rounded">
    <option value="" disabled selected>Select a Evalution</option>
  <option *ngFor="let t of titleOptions; [value]="t">

</option>

  </select>

  <div
    *ngIf="editevalutionEdit.controls['title'].errors && (!editevalutionEdit.controls['title'].pristine || submitted)"
    class="error-msg">
    <div class="text-danger" *ngIf="editevalutionEdit.controls['evalution'].hasError('required')">
       Evalution is required.
    </div>
  </div>
</div> -->
        <!-- <div class="col-md-12 form-group mb-3">
          <label for="title">Select an Evaluation Style</label>
          <select formControlName='evaluation_category_id' class="form-control form-control-rounded">
            <option value="" disabled selected>Select an Evaluation Style</option>
            <option *ngFor="let t of titleOptions" [value]="t.id">{{ t.title }}</option>
          </select>

          <div
            *ngIf="editevalutionEdit.controls['evaluation_category_id'].errors && (!editevalutionEdit.controls['evaluation_category_id'].pristine || submitted)"
            class="error-msg">
            <div class="text-danger" *ngIf="editevalutionEdit.controls['evaluation_category_id'].hasError('required')">
              Evaluation Style is required.
            </div>
          </div>
        </div> -->
      <div class="col-md-12 form-group mb-3">
  <label for="title">Select an Evaluation Style</label>
  <div class="select-wrapper">
    <select formControlName="evaluation_category_id" class="form-control form-control-rounded">
      <option value="" disabled selected>Select an Evaluation Style</option>
      <option *ngFor="let t of titleOptions" [value]="t.id">{{ t.title }}</option>
    </select>
    <span class="select-icon">&#x25BC;</span> <!-- Downward triangle -->
  </div>
  <div
    *ngIf="editevalutionEdit.controls['evaluation_category_id'].errors && (!editevalutionEdit.controls['evaluation_category_id'].pristine || submitted)"
    class="error-msg">
    <div class="text-danger" *ngIf="editevalutionEdit.controls['evaluation_category_id'].hasError('required')">
      Evaluation Style is required.
    </div>
  </div>
</div>
        <div class="col-md-12 form-group mb-3">
          <label> Image</label>
          <input type="file" class="form-control form-control-rounded image input" (change)="onFileChange($event)"
            id="fileInput" />

          <div>
            <div class="row mb-2">
              <div class="col-lg-6">
                <div class="imageToCrop2">
                  <img id="imageToCrop" style="max-width: 100%; margin-top: 20px;" *ngIf="imageSelected" />
                </div>
              </div>
              <!-- <div class="col-lg-4 text-left" *ngIf="imageSelected">
                <button (click)="cropImage()"  class=" btn btn-primary" style="margin-top: 20px;margin-left: 50px;">Crop Image</button>
              </div> -->
              <div class="col-lg-6">
                <div class="text-left" *ngIf="imageSelected">
                  <button (click)="cropImage()" class=" btn btn-primary"
                    style="margin-top: 20px;margin-left: 50px;">Crop Image</button>
                </div>
                <div class="cropper-wrapper" *ngIf="croppedImage">
                  <p class="mb-1 mt-3 text-center" *ngIf="croppedImage"><b>Cropped Image</b></p>
                  <div class="profile-picture" *ngIf="croppedImage">
                    <img [src]="updatecropped" class="rounded-image" />

                  </div>
                  <!-- <p class="mb-1 mt-3 text-center" *ngIf="imgdata &&!updatecropped&&!imageSelected"><b> Image</b></p>
                  <div class="profile-picture" *ngIf="imgdata &&!updatecropped">
                    <img [src]="imgdata" class="rounded-image" />
                  </div> -->
                </div>
                <div class="cropper-wrapper" *ngIf="imgdata &&!updatecropped&&!imageSelected">
                  <!-- <p class="mb-1 mt-3 text-center" *ngIf="croppedImage"><b>Cropped Image</b></p>
                  <div class="profile-picture" *ngIf="croppedImage">
                    <img [src]="updatecropped" class="rounded-image" />

                  </div> -->
                  <p class="mb-1 mt-3 text-center" *ngIf="imgdata &&!updatecropped&&!imageSelected"><b> Image</b></p>
                  <div class="profile-picture" *ngIf="imgdata &&!updatecropped">
                    <img [src]="imgdata" class="rounded-image" />
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div *ngIf="submitted && !imgdata" class="error-msg">
            Image is required
          </div>
          <div *ngIf="imagesize" class="text-danger">
            Image size must be 5 MB or less
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-rounded"
      (click)="modal.dismiss('cancel')">Cancel</button>
    <button ngbAutofocus class="btn btn-danger btn-rounded" (click)="updateEvalution()">Ok</button>
  </div>
</ng-template>







<ng-template #modalimage let-modal>
  <div class="p-3">
    <img [src]="modalImageUrl" alt="Full Image" style="width: 100%; max-height: 90vh; object-fit: contain;">
  </div>
</ng-template>